/* Type-to-narrow box for facet dropdowns with long value lists (see
   snippets/facet-value-search.liquid). Listens in the capture phase and stops
   propagation so typing never reaches FacetFiltersForm's debounced
   auto-submit, which would re-render the facets mid-keystroke. */
(() => {
  if (window.facetValueSearchInit) return;
  window.facetValueSearchInit = true;

  const SCOPE_SELECTOR = '.parent-display, .mobile-facets__submenu';

  function onInput(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('facet-value-search__input')) return;
    event.stopPropagation();

    const scope = input.closest(SCOPE_SELECTOR);
    if (!scope) return;
    const query = input.value.trim().toLowerCase();
    let matches = 0;

    scope.querySelectorAll('ul[role="list"] > li').forEach((item) => {
      const label = item.querySelector('.facet-checkbox__text-label');
      if (!label) return;
      const match = !query || label.textContent.toLowerCase().includes(query);
      item.classList.toggle('facet-value-search--hide', !match);
      // While searching, also surface matches normally collapsed behind
      // the "Show more" toggle.
      item.classList.toggle('facet-value-search--show', Boolean(query) && match);
      if (match) matches += 1;
    });

    const showMore = scope.querySelector('show-more-button');
    if (showMore) showMore.classList.toggle('facet-value-search--hide', Boolean(query));

    const empty = scope.querySelector('.facet-value-search__empty');
    if (empty) empty.classList.toggle('facet-value-search--hide', matches > 0);
  }

  function onKeydown(event) {
    if (event.key !== 'Enter') return;
    const input = event.target;
    if (input instanceof HTMLInputElement && input.classList.contains('facet-value-search__input')) {
      // Enter would submit the surrounding facets form and reload results.
      event.preventDefault();
      event.stopPropagation();
    }
  }

  document.addEventListener('input', onInput, true);
  document.addEventListener('keydown', onKeydown, true);
})();
